export interface CommentInputApiModel {
    resource_type: string,
    resource_id: number,
    payload: any
}